import { Controller } from "@hotwired/stimulus";

export class ConvertPointsController extends Controller {
  static targets = ["form", "input", "afterAmount", "afterPoint"];
  static values = { beforeAmount: Number, beforePoint: Number };

  connect() {
    this.convertPoints();
    this.inputTarget.addEventListener("input", this.convertPoints.bind(this));
    this.formTarget.addEventListener("submit", (this.submit.bind(this)));
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.convertPoints.bind(this));
    this.formTarget.removeEventListener("submit", (this.submit.bind(this)));
  }

  //
  convertPoints() {
    const currentAmount = Number(this.inputTarget.value);
    this.afterAmountTarget.textContent = Number(this.beforeAmountValue - currentAmount).toLocaleString();
    this.afterPointTarget.textContent = Number(this.beforePointValue + currentAmount).toLocaleString();
  }

  //
  submit(event) {
    if (!confirm("MFJPYは収穫金に変換できません。\n本当に変換しますか？")) {
      event.preventDefault();
      this.inputTarget.focus();
      //
      const submitBtn = this.formTarget.querySelector("input[type=submit]");
      if (submitBtn) {
        // 二重送信防止のdisabledを解除する
        setTimeout(() => {
          submitBtn.disabled = false;
        }, 150);
      }
    }
  }
}
